import { render, staticRenderFns } from "./InventoryCategory.vue?vue&type=template&id=1a1cd642&scoped=true"
import script from "./InventoryCategory.vue?vue&type=script&lang=js"
export * from "./InventoryCategory.vue?vue&type=script&lang=js"
import style0 from "./InventoryCategory.vue?vue&type=style&index=0&id=1a1cd642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1cd642",
  null
  
)

export default component.exports